import * as i1 from '@angular/cdk/scrolling';
import { CdkScrollable, CdkScrollableModule } from '@angular/cdk/scrolling';
import * as i0 from '@angular/core';
import { InjectionToken, forwardRef, Component, ChangeDetectionStrategy, ViewEncapsulation, Inject, EventEmitter, Optional, Input, Output, ViewChild, QueryList, ANIMATION_MODULE_TYPE, ContentChildren, ContentChild, NgModule } from '@angular/core';
import { MatCommonModule } from '@angular/material/core';
import * as i2 from '@angular/cdk/a11y';
import * as i4 from '@angular/cdk/bidi';
import { coerceBooleanProperty, coerceNumberProperty } from '@angular/cdk/coercion';
import { ESCAPE, hasModifierKey } from '@angular/cdk/keycodes';
import * as i3 from '@angular/cdk/platform';
import { DOCUMENT } from '@angular/common';
import { Subject, fromEvent, merge } from 'rxjs';
import { filter, map, mapTo, takeUntil, distinctUntilChanged, take, startWith, debounceTime } from 'rxjs/operators';
import { trigger, state, style, transition, animate } from '@angular/animations';

/**
 * Animations used by the Material drawers.
 * @docs-private
 */
const _c0 = ["*"];
const _c1 = ["content"];
const _c2 = [[["mat-drawer"]], [["mat-drawer-content"]], "*"];
const _c3 = ["mat-drawer", "mat-drawer-content", "*"];
function MatDrawerContainer_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵlistener("click", function MatDrawerContainer_Conditional_0_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._onBackdropClicked());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("mat-drawer-shown", ctx_r1._isShowingBackdrop());
  }
}
function MatDrawerContainer_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-drawer-content");
    i0.ɵɵprojection(1, 2);
    i0.ɵɵelementEnd();
  }
}
const _c4 = [[["mat-sidenav"]], [["mat-sidenav-content"]], "*"];
const _c5 = ["mat-sidenav", "mat-sidenav-content", "*"];
function MatSidenavContainer_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵlistener("click", function MatSidenavContainer_Conditional_0_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._onBackdropClicked());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("mat-drawer-shown", ctx_r1._isShowingBackdrop());
  }
}
function MatSidenavContainer_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-sidenav-content");
    i0.ɵɵprojection(1, 2);
    i0.ɵɵelementEnd();
  }
}
const _c6 = ".mat-drawer-container{position:relative;z-index:1;color:var(--mat-sidenav-content-text-color);background-color:var(--mat-sidenav-content-background-color);box-sizing:border-box;-webkit-overflow-scrolling:touch;display:block;overflow:hidden}.mat-drawer-container[fullscreen]{top:0;left:0;right:0;bottom:0;position:absolute}.mat-drawer-container[fullscreen].mat-drawer-container-has-open{overflow:hidden}.mat-drawer-container.mat-drawer-container-explicit-backdrop .mat-drawer-side{z-index:3}.mat-drawer-container.ng-animate-disabled .mat-drawer-backdrop,.mat-drawer-container.ng-animate-disabled .mat-drawer-content,.ng-animate-disabled .mat-drawer-container .mat-drawer-backdrop,.ng-animate-disabled .mat-drawer-container .mat-drawer-content{transition:none}.mat-drawer-backdrop{top:0;left:0;right:0;bottom:0;position:absolute;display:block;z-index:3;visibility:hidden}.mat-drawer-backdrop.mat-drawer-shown{visibility:visible;background-color:var(--mat-sidenav-scrim-color)}.mat-drawer-transition .mat-drawer-backdrop{transition-duration:400ms;transition-timing-function:cubic-bezier(0.25, 0.8, 0.25, 1);transition-property:background-color,visibility}.cdk-high-contrast-active .mat-drawer-backdrop{opacity:.5}.mat-drawer-content{position:relative;z-index:1;display:block;height:100%;overflow:auto}.mat-drawer-transition .mat-drawer-content{transition-duration:400ms;transition-timing-function:cubic-bezier(0.25, 0.8, 0.25, 1);transition-property:transform,margin-left,margin-right}.mat-drawer{position:relative;z-index:4;color:var(--mat-sidenav-container-text-color);box-shadow:var(--mat-sidenav-container-elevation-shadow);background-color:var(--mat-sidenav-container-background-color);border-top-right-radius:var(--mat-sidenav-container-shape);border-bottom-right-radius:var(--mat-sidenav-container-shape);width:var(--mat-sidenav-container-width);display:block;position:absolute;top:0;bottom:0;z-index:3;outline:0;box-sizing:border-box;overflow-y:auto;transform:translate3d(-100%, 0, 0)}.cdk-high-contrast-active .mat-drawer,.cdk-high-contrast-active [dir=rtl] .mat-drawer.mat-drawer-end{border-right:solid 1px currentColor}.cdk-high-contrast-active [dir=rtl] .mat-drawer,.cdk-high-contrast-active .mat-drawer.mat-drawer-end{border-left:solid 1px currentColor;border-right:none}.mat-drawer.mat-drawer-side{z-index:2}.mat-drawer.mat-drawer-end{right:0;transform:translate3d(100%, 0, 0);border-top-left-radius:var(--mat-sidenav-container-shape);border-bottom-left-radius:var(--mat-sidenav-container-shape);border-top-right-radius:0;border-bottom-right-radius:0}[dir=rtl] .mat-drawer{border-top-left-radius:var(--mat-sidenav-container-shape);border-bottom-left-radius:var(--mat-sidenav-container-shape);border-top-right-radius:0;border-bottom-right-radius:0;transform:translate3d(100%, 0, 0)}[dir=rtl] .mat-drawer.mat-drawer-end{border-top-right-radius:var(--mat-sidenav-container-shape);border-bottom-right-radius:var(--mat-sidenav-container-shape);border-top-left-radius:0;border-bottom-left-radius:0;left:0;right:auto;transform:translate3d(-100%, 0, 0)}.mat-drawer[style*=\"visibility: hidden\"]{display:none}.mat-drawer-side{box-shadow:none;border-right-color:var(--mat-sidenav-container-divider-color);border-right-width:1px;border-right-style:solid}.mat-drawer-side.mat-drawer-end{border-left-color:var(--mat-sidenav-container-divider-color);border-left-width:1px;border-left-style:solid;border-right:none}[dir=rtl] .mat-drawer-side{border-left-color:var(--mat-sidenav-container-divider-color);border-left-width:1px;border-left-style:solid;border-right:none}[dir=rtl] .mat-drawer-side.mat-drawer-end{border-right-color:var(--mat-sidenav-container-divider-color);border-right-width:1px;border-right-style:solid;border-left:none}.mat-drawer-inner-container{width:100%;height:100%;overflow:auto;-webkit-overflow-scrolling:touch}.mat-sidenav-fixed{position:fixed}";
const matDrawerAnimations = {
  /** Animation that slides a drawer in and out. */
  transformDrawer: /*#__PURE__*/trigger('transform', [
  /*#__PURE__*/
  // We remove the `transform` here completely, rather than setting it to zero, because:
  // 1. Having a transform can cause elements with ripples or an animated
  //    transform to shift around in Chrome with an RTL layout (see #10023).
  // 2. 3d transforms causes text to appear blurry on IE and Edge.
  state('open, open-instant', /*#__PURE__*/style({
    'transform': 'none',
    'visibility': 'visible'
  })), /*#__PURE__*/state('void', /*#__PURE__*/style({
    // Avoids the shadow showing up when closed in SSR.
    'box-shadow': 'none',
    'visibility': 'hidden'
  })), /*#__PURE__*/transition('void => open-instant', /*#__PURE__*/animate('0ms')), /*#__PURE__*/transition('void <=> open, open-instant => void', /*#__PURE__*/animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)'))])
};

/**
 * Throws an exception when two MatDrawer are matching the same position.
 * @docs-private
 */
function throwMatDuplicatedDrawerError(position) {
  throw Error(`A drawer was already declared for 'position="${position}"'`);
}
/** Configures whether drawers should use auto sizing by default. */
const MAT_DRAWER_DEFAULT_AUTOSIZE = /*#__PURE__*/new InjectionToken('MAT_DRAWER_DEFAULT_AUTOSIZE', {
  providedIn: 'root',
  factory: MAT_DRAWER_DEFAULT_AUTOSIZE_FACTORY
});
/**
 * Used to provide a drawer container to a drawer while avoiding circular references.
 * @docs-private
 */
const MAT_DRAWER_CONTAINER = /*#__PURE__*/new InjectionToken('MAT_DRAWER_CONTAINER');
/** @docs-private */
function MAT_DRAWER_DEFAULT_AUTOSIZE_FACTORY() {
  return false;
}
let MatDrawerContent = /*#__PURE__*/(() => {
  class MatDrawerContent extends CdkScrollable {
    constructor(_changeDetectorRef, _container, elementRef, scrollDispatcher, ngZone) {
      super(elementRef, scrollDispatcher, ngZone);
      this._changeDetectorRef = _changeDetectorRef;
      this._container = _container;
    }
    ngAfterContentInit() {
      this._container._contentMarginChanges.subscribe(() => {
        this._changeDetectorRef.markForCheck();
      });
    }
    static {
      this.ɵfac = function MatDrawerContent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MatDrawerContent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(forwardRef(() => MatDrawerContainer)), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.ScrollDispatcher), i0.ɵɵdirectiveInject(i0.NgZone));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MatDrawerContent,
        selectors: [["mat-drawer-content"]],
        hostAttrs: [1, "mat-drawer-content"],
        hostVars: 4,
        hostBindings: function MatDrawerContent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("margin-left", ctx._container._contentMargins.left, "px")("margin-right", ctx._container._contentMargins.right, "px");
          }
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: CdkScrollable,
          useExisting: MatDrawerContent
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function MatDrawerContent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return MatDrawerContent;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * This component corresponds to a drawer that can be opened on the drawer container.
 */
let MatDrawer = /*#__PURE__*/(() => {
  class MatDrawer {
    /** The side that the drawer is attached to. */
    get position() {
      return this._position;
    }
    set position(value) {
      // Make sure we have a valid value.
      value = value === 'end' ? 'end' : 'start';
      if (value !== this._position) {
        // Static inputs in Ivy are set before the element is in the DOM.
        if (this._isAttached) {
          this._updatePositionInParent(value);
        }
        this._position = value;
        this.onPositionChanged.emit();
      }
    }
    /** Mode of the drawer; one of 'over', 'push' or 'side'. */
    get mode() {
      return this._mode;
    }
    set mode(value) {
      this._mode = value;
      this._updateFocusTrapState();
      this._modeChanged.next();
    }
    /** Whether the drawer can be closed with the escape key or by clicking on the backdrop. */
    get disableClose() {
      return this._disableClose;
    }
    set disableClose(value) {
      this._disableClose = coerceBooleanProperty(value);
    }
    /**
     * Whether the drawer should focus the first focusable element automatically when opened.
     * Defaults to false in when `mode` is set to `side`, otherwise defaults to `true`. If explicitly
     * enabled, focus will be moved into the sidenav in `side` mode as well.
     * @breaking-change 14.0.0 Remove boolean option from autoFocus. Use string or AutoFocusTarget
     * instead.
     */
    get autoFocus() {
      const value = this._autoFocus;
      // Note that usually we don't allow autoFocus to be set to `first-tabbable` in `side` mode,
      // because we don't know how the sidenav is being used, but in some cases it still makes
      // sense to do it. The consumer can explicitly set `autoFocus`.
      if (value == null) {
        if (this.mode === 'side') {
          return 'dialog';
        } else {
          return 'first-tabbable';
        }
      }
      return value;
    }
    set autoFocus(value) {
      if (value === 'true' || value === 'false' || value == null) {
        value = coerceBooleanProperty(value);
      }
      this._autoFocus = value;
    }
    /**
     * Whether the drawer is opened. We overload this because we trigger an event when it
     * starts or end.
     */
    get opened() {
      return this._opened;
    }
    set opened(value) {
      this.toggle(coerceBooleanProperty(value));
    }
    constructor(_elementRef, _focusTrapFactory, _focusMonitor, _platform, _ngZone, _interactivityChecker, _doc, _container) {
      this._elementRef = _elementRef;
      this._focusTrapFactory = _focusTrapFactory;
      this._focusMonitor = _focusMonitor;
      this._platform = _platform;
      this._ngZone = _ngZone;
      this._interactivityChecker = _interactivityChecker;
      this._doc = _doc;
      this._container = _container;
      this._focusTrap = null;
      this._elementFocusedBeforeDrawerWasOpened = null;
      /** Whether the drawer is initialized. Used for disabling the initial animation. */
      this._enableAnimations = false;
      this._position = 'start';
      this._mode = 'over';
      this._disableClose = false;
      this._opened = false;
      /** Emits whenever the drawer has started animating. */
      this._animationStarted = new Subject();
      /** Emits whenever the drawer is done animating. */
      this._animationEnd = new Subject();
      /** Current state of the sidenav animation. */
      this._animationState = 'void';
      /** Event emitted when the drawer open state is changed. */
      this.openedChange =
      // Note this has to be async in order to avoid some issues with two-bindings (see #8872).
      new EventEmitter(/* isAsync */true);
      /** Event emitted when the drawer has been opened. */
      this._openedStream = this.openedChange.pipe(filter(o => o), map(() => {}));
      /** Event emitted when the drawer has started opening. */
      this.openedStart = this._animationStarted.pipe(filter(e => e.fromState !== e.toState && e.toState.indexOf('open') === 0), mapTo(undefined));
      /** Event emitted when the drawer has been closed. */
      this._closedStream = this.openedChange.pipe(filter(o => !o), map(() => {}));
      /** Event emitted when the drawer has started closing. */
      this.closedStart = this._animationStarted.pipe(filter(e => e.fromState !== e.toState && e.toState === 'void'), mapTo(undefined));
      /** Emits when the component is destroyed. */
      this._destroyed = new Subject();
      /** Event emitted when the drawer's position changes. */
      // tslint:disable-next-line:no-output-on-prefix
      this.onPositionChanged = new EventEmitter();
      /**
       * An observable that emits when the drawer mode changes. This is used by the drawer container to
       * to know when to when the mode changes so it can adapt the margins on the content.
       */
      this._modeChanged = new Subject();
      this.openedChange.subscribe(opened => {
        if (opened) {
          if (this._doc) {
            this._elementFocusedBeforeDrawerWasOpened = this._doc.activeElement;
          }
          this._takeFocus();
        } else if (this._isFocusWithinDrawer()) {
          this._restoreFocus(this._openedVia || 'program');
        }
      });
      /**
       * Listen to `keydown` events outside the zone so that change detection is not run every
       * time a key is pressed. Instead we re-enter the zone only if the `ESC` key is pressed
       * and we don't have close disabled.
       */
      this._ngZone.runOutsideAngular(() => {
        fromEvent(this._elementRef.nativeElement, 'keydown').pipe(filter(event => {
          return event.keyCode === ESCAPE && !this.disableClose && !hasModifierKey(event);
        }), takeUntil(this._destroyed)).subscribe(event => this._ngZone.run(() => {
          this.close();
          event.stopPropagation();
          event.preventDefault();
        }));
      });
      // We need a Subject with distinctUntilChanged, because the `done` event
      // fires twice on some browsers. See https://github.com/angular/angular/issues/24084
      this._animationEnd.pipe(distinctUntilChanged((x, y) => {
        return x.fromState === y.fromState && x.toState === y.toState;
      })).subscribe(event => {
        const {
          fromState,
          toState
        } = event;
        if (toState.indexOf('open') === 0 && fromState === 'void' || toState === 'void' && fromState.indexOf('open') === 0) {
          this.openedChange.emit(this._opened);
        }
      });
    }
    /**
     * Focuses the provided element. If the element is not focusable, it will add a tabIndex
     * attribute to forcefully focus it. The attribute is removed after focus is moved.
     * @param element The element to focus.
     */
    _forceFocus(element, options) {
      if (!this._interactivityChecker.isFocusable(element)) {
        element.tabIndex = -1;
        // The tabindex attribute should be removed to avoid navigating to that element again
        this._ngZone.runOutsideAngular(() => {
          const callback = () => {
            element.removeEventListener('blur', callback);
            element.removeEventListener('mousedown', callback);
            element.removeAttribute('tabindex');
          };
          element.addEventListener('blur', callback);
          element.addEventListener('mousedown', callback);
        });
      }
      element.focus(options);
    }
    /**
     * Focuses the first element that matches the given selector within the focus trap.
     * @param selector The CSS selector for the element to set focus to.
     */
    _focusByCssSelector(selector, options) {
      let elementToFocus = this._elementRef.nativeElement.querySelector(selector);
      if (elementToFocus) {
        this._forceFocus(elementToFocus, options);
      }
    }
    /**
     * Moves focus into the drawer. Note that this works even if
     * the focus trap is disabled in `side` mode.
     */
    _takeFocus() {
      if (!this._focusTrap) {
        return;
      }
      const element = this._elementRef.nativeElement;
      // When autoFocus is not on the sidenav, if the element cannot be focused or does
      // not exist, focus the sidenav itself so the keyboard navigation still works.
      // We need to check that `focus` is a function due to Universal.
      switch (this.autoFocus) {
        case false:
        case 'dialog':
          return;
        case true:
        case 'first-tabbable':
          this._focusTrap.focusInitialElementWhenReady().then(hasMovedFocus => {
            if (!hasMovedFocus && typeof this._elementRef.nativeElement.focus === 'function') {
              element.focus();
            }
          });
          break;
        case 'first-heading':
          this._focusByCssSelector('h1, h2, h3, h4, h5, h6, [role="heading"]');
          break;
        default:
          this._focusByCssSelector(this.autoFocus);
          break;
      }
    }
    /**
     * Restores focus to the element that was originally focused when the drawer opened.
     * If no element was focused at that time, the focus will be restored to the drawer.
     */
    _restoreFocus(focusOrigin) {
      if (this.autoFocus === 'dialog') {
        return;
      }
      if (this._elementFocusedBeforeDrawerWasOpened) {
        this._focusMonitor.focusVia(this._elementFocusedBeforeDrawerWasOpened, focusOrigin);
      } else {
        this._elementRef.nativeElement.blur();
      }
      this._elementFocusedBeforeDrawerWasOpened = null;
    }
    /** Whether focus is currently within the drawer. */
    _isFocusWithinDrawer() {
      const activeEl = this._doc.activeElement;
      return !!activeEl && this._elementRef.nativeElement.contains(activeEl);
    }
    ngAfterViewInit() {
      this._isAttached = true;
      // Only update the DOM position when the sidenav is positioned at
      // the end since we project the sidenav before the content by default.
      if (this._position === 'end') {
        this._updatePositionInParent('end');
      }
      // Needs to happen after the position is updated
      // so the focus trap anchors are in the right place.
      if (this._platform.isBrowser) {
        this._focusTrap = this._focusTrapFactory.create(this._elementRef.nativeElement);
        this._updateFocusTrapState();
      }
    }
    ngAfterContentChecked() {
      // Enable the animations after the lifecycle hooks have run, in order to avoid animating
      // drawers that are open by default. When we're on the server, we shouldn't enable the
      // animations, because we don't want the drawer to animate the first time the user sees
      // the page.
      if (this._platform.isBrowser) {
        this._enableAnimations = true;
      }
    }
    ngOnDestroy() {
      this._focusTrap?.destroy();
      this._anchor?.remove();
      this._anchor = null;
      this._animationStarted.complete();
      this._animationEnd.complete();
      this._modeChanged.complete();
      this._destroyed.next();
      this._destroyed.complete();
    }
    /**
     * Open the drawer.
     * @param openedVia Whether the drawer was opened by a key press, mouse click or programmatically.
     * Used for focus management after the sidenav is closed.
     */
    open(openedVia) {
      return this.toggle(true, openedVia);
    }
    /** Close the drawer. */
    close() {
      return this.toggle(false);
    }
    /** Closes the drawer with context that the backdrop was clicked. */
    _closeViaBackdropClick() {
      // If the drawer is closed upon a backdrop click, we always want to restore focus. We
      // don't need to check whether focus is currently in the drawer, as clicking on the
      // backdrop causes blurs the active element.
      return this._setOpen(/* isOpen */false, /* restoreFocus */true, 'mouse');
    }
    /**
     * Toggle this drawer.
     * @param isOpen Whether the drawer should be open.
     * @param openedVia Whether the drawer was opened by a key press, mouse click or programmatically.
     * Used for focus management after the sidenav is closed.
     */
    toggle(isOpen = !this.opened, openedVia) {
      // If the focus is currently inside the drawer content and we are closing the drawer,
      // restore the focus to the initially focused element (when the drawer opened).
      if (isOpen && openedVia) {
        this._openedVia = openedVia;
      }
      const result = this._setOpen(isOpen, /* restoreFocus */!isOpen && this._isFocusWithinDrawer(), this._openedVia || 'program');
      if (!isOpen) {
        this._openedVia = null;
      }
      return result;
    }
    /**
     * Toggles the opened state of the drawer.
     * @param isOpen Whether the drawer should open or close.
     * @param restoreFocus Whether focus should be restored on close.
     * @param focusOrigin Origin to use when restoring focus.
     */
    _setOpen(isOpen, restoreFocus, focusOrigin) {
      this._opened = isOpen;
      if (isOpen) {
        this._animationState = this._enableAnimations ? 'open' : 'open-instant';
      } else {
        this._animationState = 'void';
        if (restoreFocus) {
          this._restoreFocus(focusOrigin);
        }
      }
      this._updateFocusTrapState();
      return new Promise(resolve => {
        this.openedChange.pipe(take(1)).subscribe(open => resolve(open ? 'open' : 'close'));
      });
    }
    _getWidth() {
      return this._elementRef.nativeElement ? this._elementRef.nativeElement.offsetWidth || 0 : 0;
    }
    /** Updates the enabled state of the focus trap. */
    _updateFocusTrapState() {
      if (this._focusTrap) {
        // Trap focus only if the backdrop is enabled. Otherwise, allow end user to interact with the
        // sidenav content.
        this._focusTrap.enabled = !!this._container?.hasBackdrop;
      }
    }
    /**
     * Updates the position of the drawer in the DOM. We need to move the element around ourselves
     * when it's in the `end` position so that it comes after the content and the visual order
     * matches the tab order. We also need to be able to move it back to `start` if the sidenav
     * started off as `end` and was changed to `start`.
     */
    _updatePositionInParent(newPosition) {
      // Don't move the DOM node around on the server, because it can throw off hydration.
      if (!this._platform.isBrowser) {
        return;
      }
      const element = this._elementRef.nativeElement;
      const parent = element.parentNode;
      if (newPosition === 'end') {
        if (!this._anchor) {
          this._anchor = this._doc.createComment('mat-drawer-anchor');
          parent.insertBefore(this._anchor, element);
        }
        parent.appendChild(element);
      } else if (this._anchor) {
        this._anchor.parentNode.insertBefore(element, this._anchor);
      }
    }
    static {
      this.ɵfac = function MatDrawer_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MatDrawer)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2.FocusTrapFactory), i0.ɵɵdirectiveInject(i2.FocusMonitor), i0.ɵɵdirectiveInject(i3.Platform), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i2.InteractivityChecker), i0.ɵɵdirectiveInject(DOCUMENT, 8), i0.ɵɵdirectiveInject(MAT_DRAWER_CONTAINER, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MatDrawer,
        selectors: [["mat-drawer"]],
        viewQuery: function MatDrawer_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c1, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._content = _t.first);
          }
        },
        hostAttrs: ["tabIndex", "-1", 1, "mat-drawer"],
        hostVars: 12,
        hostBindings: function MatDrawer_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵsyntheticHostListener("@transform.start", function MatDrawer_animation_transform_start_HostBindingHandler($event) {
              return ctx._animationStarted.next($event);
            })("@transform.done", function MatDrawer_animation_transform_done_HostBindingHandler($event) {
              return ctx._animationEnd.next($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵsyntheticHostProperty("@transform", ctx._animationState);
            i0.ɵɵattribute("align", null);
            i0.ɵɵclassProp("mat-drawer-end", ctx.position === "end")("mat-drawer-over", ctx.mode === "over")("mat-drawer-push", ctx.mode === "push")("mat-drawer-side", ctx.mode === "side")("mat-drawer-opened", ctx.opened);
          }
        },
        inputs: {
          position: "position",
          mode: "mode",
          disableClose: "disableClose",
          autoFocus: "autoFocus",
          opened: "opened"
        },
        outputs: {
          openedChange: "openedChange",
          _openedStream: "opened",
          openedStart: "openedStart",
          _closedStream: "closed",
          closedStart: "closedStart",
          onPositionChanged: "positionChanged"
        },
        exportAs: ["matDrawer"],
        ngContentSelectors: _c0,
        decls: 3,
        vars: 0,
        consts: [["content", ""], ["cdkScrollable", "", 1, "mat-drawer-inner-container"]],
        template: function MatDrawer_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        dependencies: [CdkScrollable],
        encapsulation: 2,
        data: {
          animation: [matDrawerAnimations.transformDrawer]
        },
        changeDetection: 0
      });
    }
  }
  return MatDrawer;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * `<mat-drawer-container>` component.
 *
 * This is the parent component to one or two `<mat-drawer>`s that validates the state internally
 * and coordinates the backdrop and content styling.
 */
let MatDrawerContainer = /*#__PURE__*/(() => {
  class MatDrawerContainer {
    /** The drawer child with the `start` position. */
    get start() {
      return this._start;
    }
    /** The drawer child with the `end` position. */
    get end() {
      return this._end;
    }
    /**
     * Whether to automatically resize the container whenever
     * the size of any of its drawers changes.
     *
     * **Use at your own risk!** Enabling this option can cause layout thrashing by measuring
     * the drawers on every change detection cycle. Can be configured globally via the
     * `MAT_DRAWER_DEFAULT_AUTOSIZE` token.
     */
    get autosize() {
      return this._autosize;
    }
    set autosize(value) {
      this._autosize = coerceBooleanProperty(value);
    }
    /**
     * Whether the drawer container should have a backdrop while one of the sidenavs is open.
     * If explicitly set to `true`, the backdrop will be enabled for drawers in the `side`
     * mode as well.
     */
    get hasBackdrop() {
      return this._drawerHasBackdrop(this._start) || this._drawerHasBackdrop(this._end);
    }
    set hasBackdrop(value) {
      this._backdropOverride = value == null ? null : coerceBooleanProperty(value);
    }
    /** Reference to the CdkScrollable instance that wraps the scrollable content. */
    get scrollable() {
      return this._userContent || this._content;
    }
    constructor(_dir, _element, _ngZone, _changeDetectorRef, viewportRuler, defaultAutosize = false, _animationMode) {
      this._dir = _dir;
      this._element = _element;
      this._ngZone = _ngZone;
      this._changeDetectorRef = _changeDetectorRef;
      this._animationMode = _animationMode;
      /** Drawers that belong to this container. */
      this._drawers = new QueryList();
      /** Event emitted when the drawer backdrop is clicked. */
      this.backdropClick = new EventEmitter();
      /** Emits when the component is destroyed. */
      this._destroyed = new Subject();
      /** Emits on every ngDoCheck. Used for debouncing reflows. */
      this._doCheckSubject = new Subject();
      /**
       * Margins to be applied to the content. These are used to push / shrink the drawer content when a
       * drawer is open. We use margin rather than transform even for push mode because transform breaks
       * fixed position elements inside of the transformed element.
       */
      this._contentMargins = {
        left: null,
        right: null
      };
      this._contentMarginChanges = new Subject();
      // If a `Dir` directive exists up the tree, listen direction changes
      // and update the left/right properties to point to the proper start/end.
      if (_dir) {
        _dir.change.pipe(takeUntil(this._destroyed)).subscribe(() => {
          this._validateDrawers();
          this.updateContentMargins();
        });
      }
      // Since the minimum width of the sidenav depends on the viewport width,
      // we need to recompute the margins if the viewport changes.
      viewportRuler.change().pipe(takeUntil(this._destroyed)).subscribe(() => this.updateContentMargins());
      this._autosize = defaultAutosize;
    }
    ngAfterContentInit() {
      this._allDrawers.changes.pipe(startWith(this._allDrawers), takeUntil(this._destroyed)).subscribe(drawer => {
        this._drawers.reset(drawer.filter(item => !item._container || item._container === this));
        this._drawers.notifyOnChanges();
      });
      this._drawers.changes.pipe(startWith(null)).subscribe(() => {
        this._validateDrawers();
        this._drawers.forEach(drawer => {
          this._watchDrawerToggle(drawer);
          this._watchDrawerPosition(drawer);
          this._watchDrawerMode(drawer);
        });
        if (!this._drawers.length || this._isDrawerOpen(this._start) || this._isDrawerOpen(this._end)) {
          this.updateContentMargins();
        }
        this._changeDetectorRef.markForCheck();
      });
      // Avoid hitting the NgZone through the debounce timeout.
      this._ngZone.runOutsideAngular(() => {
        this._doCheckSubject.pipe(debounceTime(10),
        // Arbitrary debounce time, less than a frame at 60fps
        takeUntil(this._destroyed)).subscribe(() => this.updateContentMargins());
      });
    }
    ngOnDestroy() {
      this._contentMarginChanges.complete();
      this._doCheckSubject.complete();
      this._drawers.destroy();
      this._destroyed.next();
      this._destroyed.complete();
    }
    /** Calls `open` of both start and end drawers */
    open() {
      this._drawers.forEach(drawer => drawer.open());
    }
    /** Calls `close` of both start and end drawers */
    close() {
      this._drawers.forEach(drawer => drawer.close());
    }
    /**
     * Recalculates and updates the inline styles for the content. Note that this should be used
     * sparingly, because it causes a reflow.
     */
    updateContentMargins() {
      // 1. For drawers in `over` mode, they don't affect the content.
      // 2. For drawers in `side` mode they should shrink the content. We do this by adding to the
      //    left margin (for left drawer) or right margin (for right the drawer).
      // 3. For drawers in `push` mode the should shift the content without resizing it. We do this by
      //    adding to the left or right margin and simultaneously subtracting the same amount of
      //    margin from the other side.
      let left = 0;
      let right = 0;
      if (this._left && this._left.opened) {
        if (this._left.mode == 'side') {
          left += this._left._getWidth();
        } else if (this._left.mode == 'push') {
          const width = this._left._getWidth();
          left += width;
          right -= width;
        }
      }
      if (this._right && this._right.opened) {
        if (this._right.mode == 'side') {
          right += this._right._getWidth();
        } else if (this._right.mode == 'push') {
          const width = this._right._getWidth();
          right += width;
          left -= width;
        }
      }
      // If either `right` or `left` is zero, don't set a style to the element. This
      // allows users to specify a custom size via CSS class in SSR scenarios where the
      // measured widths will always be zero. Note that we reset to `null` here, rather
      // than below, in order to ensure that the types in the `if` below are consistent.
      left = left || null;
      right = right || null;
      if (left !== this._contentMargins.left || right !== this._contentMargins.right) {
        this._contentMargins = {
          left,
          right
        };
        // Pull back into the NgZone since in some cases we could be outside. We need to be careful
        // to do it only when something changed, otherwise we can end up hitting the zone too often.
        this._ngZone.run(() => this._contentMarginChanges.next(this._contentMargins));
      }
    }
    ngDoCheck() {
      // If users opted into autosizing, do a check every change detection cycle.
      if (this._autosize && this._isPushed()) {
        // Run outside the NgZone, otherwise the debouncer will throw us into an infinite loop.
        this._ngZone.runOutsideAngular(() => this._doCheckSubject.next());
      }
    }
    /**
     * Subscribes to drawer events in order to set a class on the main container element when the
     * drawer is open and the backdrop is visible. This ensures any overflow on the container element
     * is properly hidden.
     */
    _watchDrawerToggle(drawer) {
      drawer._animationStarted.pipe(filter(event => event.fromState !== event.toState), takeUntil(this._drawers.changes)).subscribe(event => {
        // Set the transition class on the container so that the animations occur. This should not
        // be set initially because animations should only be triggered via a change in state.
        if (event.toState !== 'open-instant' && this._animationMode !== 'NoopAnimations') {
          this._element.nativeElement.classList.add('mat-drawer-transition');
        }
        this.updateContentMargins();
        this._changeDetectorRef.markForCheck();
      });
      if (drawer.mode !== 'side') {
        drawer.openedChange.pipe(takeUntil(this._drawers.changes)).subscribe(() => this._setContainerClass(drawer.opened));
      }
    }
    /**
     * Subscribes to drawer onPositionChanged event in order to
     * re-validate drawers when the position changes.
     */
    _watchDrawerPosition(drawer) {
      if (!drawer) {
        return;
      }
      // NOTE: We need to wait for the microtask queue to be empty before validating,
      // since both drawers may be swapping positions at the same time.
      drawer.onPositionChanged.pipe(takeUntil(this._drawers.changes)).subscribe(() => {
        this._ngZone.onMicrotaskEmpty.pipe(take(1)).subscribe(() => {
          this._validateDrawers();
        });
      });
    }
    /** Subscribes to changes in drawer mode so we can run change detection. */
    _watchDrawerMode(drawer) {
      if (drawer) {
        drawer._modeChanged.pipe(takeUntil(merge(this._drawers.changes, this._destroyed))).subscribe(() => {
          this.updateContentMargins();
          this._changeDetectorRef.markForCheck();
        });
      }
    }
    /** Toggles the 'mat-drawer-opened' class on the main 'mat-drawer-container' element. */
    _setContainerClass(isAdd) {
      const classList = this._element.nativeElement.classList;
      const className = 'mat-drawer-container-has-open';
      if (isAdd) {
        classList.add(className);
      } else {
        classList.remove(className);
      }
    }
    /** Validate the state of the drawer children components. */
    _validateDrawers() {
      this._start = this._end = null;
      // Ensure that we have at most one start and one end drawer.
      this._drawers.forEach(drawer => {
        if (drawer.position == 'end') {
          if (this._end != null && (typeof ngDevMode === 'undefined' || ngDevMode)) {
            throwMatDuplicatedDrawerError('end');
          }
          this._end = drawer;
        } else {
          if (this._start != null && (typeof ngDevMode === 'undefined' || ngDevMode)) {
            throwMatDuplicatedDrawerError('start');
          }
          this._start = drawer;
        }
      });
      this._right = this._left = null;
      // Detect if we're LTR or RTL.
      if (this._dir && this._dir.value === 'rtl') {
        this._left = this._end;
        this._right = this._start;
      } else {
        this._left = this._start;
        this._right = this._end;
      }
    }
    /** Whether the container is being pushed to the side by one of the drawers. */
    _isPushed() {
      return this._isDrawerOpen(this._start) && this._start.mode != 'over' || this._isDrawerOpen(this._end) && this._end.mode != 'over';
    }
    _onBackdropClicked() {
      this.backdropClick.emit();
      this._closeModalDrawersViaBackdrop();
    }
    _closeModalDrawersViaBackdrop() {
      // Close all open drawers where closing is not disabled and the mode is not `side`.
      [this._start, this._end].filter(drawer => drawer && !drawer.disableClose && this._drawerHasBackdrop(drawer)).forEach(drawer => drawer._closeViaBackdropClick());
    }
    _isShowingBackdrop() {
      return this._isDrawerOpen(this._start) && this._drawerHasBackdrop(this._start) || this._isDrawerOpen(this._end) && this._drawerHasBackdrop(this._end);
    }
    _isDrawerOpen(drawer) {
      return drawer != null && drawer.opened;
    }
    // Whether argument drawer should have a backdrop when it opens
    _drawerHasBackdrop(drawer) {
      if (this._backdropOverride == null) {
        return !!drawer && drawer.mode !== 'side';
      }
      return this._backdropOverride;
    }
    static {
      this.ɵfac = function MatDrawerContainer_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MatDrawerContainer)(i0.ɵɵdirectiveInject(i4.Directionality, 8), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.ViewportRuler), i0.ɵɵdirectiveInject(MAT_DRAWER_DEFAULT_AUTOSIZE), i0.ɵɵdirectiveInject(ANIMATION_MODULE_TYPE, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MatDrawerContainer,
        selectors: [["mat-drawer-container"]],
        contentQueries: function MatDrawerContainer_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, MatDrawerContent, 5);
            i0.ɵɵcontentQuery(dirIndex, MatDrawer, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._content = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._allDrawers = _t);
          }
        },
        viewQuery: function MatDrawerContainer_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(MatDrawerContent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._userContent = _t.first);
          }
        },
        hostAttrs: [1, "mat-drawer-container"],
        hostVars: 2,
        hostBindings: function MatDrawerContainer_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("mat-drawer-container-explicit-backdrop", ctx._backdropOverride);
          }
        },
        inputs: {
          autosize: "autosize",
          hasBackdrop: "hasBackdrop"
        },
        outputs: {
          backdropClick: "backdropClick"
        },
        exportAs: ["matDrawerContainer"],
        features: [i0.ɵɵProvidersFeature([{
          provide: MAT_DRAWER_CONTAINER,
          useExisting: MatDrawerContainer
        }])],
        ngContentSelectors: _c3,
        decls: 4,
        vars: 2,
        consts: [[1, "mat-drawer-backdrop", 3, "mat-drawer-shown"], [1, "mat-drawer-backdrop", 3, "click"]],
        template: function MatDrawerContainer_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c2);
            i0.ɵɵtemplate(0, MatDrawerContainer_Conditional_0_Template, 1, 2, "div", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵprojection(2, 1);
            i0.ɵɵtemplate(3, MatDrawerContainer_Conditional_3_Template, 2, 0, "mat-drawer-content");
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.hasBackdrop ? 0 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(!ctx._content ? 3 : -1);
          }
        },
        dependencies: [MatDrawerContent],
        styles: [".mat-drawer-container{position:relative;z-index:1;color:var(--mat-sidenav-content-text-color);background-color:var(--mat-sidenav-content-background-color);box-sizing:border-box;-webkit-overflow-scrolling:touch;display:block;overflow:hidden}.mat-drawer-container[fullscreen]{top:0;left:0;right:0;bottom:0;position:absolute}.mat-drawer-container[fullscreen].mat-drawer-container-has-open{overflow:hidden}.mat-drawer-container.mat-drawer-container-explicit-backdrop .mat-drawer-side{z-index:3}.mat-drawer-container.ng-animate-disabled .mat-drawer-backdrop,.mat-drawer-container.ng-animate-disabled .mat-drawer-content,.ng-animate-disabled .mat-drawer-container .mat-drawer-backdrop,.ng-animate-disabled .mat-drawer-container .mat-drawer-content{transition:none}.mat-drawer-backdrop{top:0;left:0;right:0;bottom:0;position:absolute;display:block;z-index:3;visibility:hidden}.mat-drawer-backdrop.mat-drawer-shown{visibility:visible;background-color:var(--mat-sidenav-scrim-color)}.mat-drawer-transition .mat-drawer-backdrop{transition-duration:400ms;transition-timing-function:cubic-bezier(0.25, 0.8, 0.25, 1);transition-property:background-color,visibility}.cdk-high-contrast-active .mat-drawer-backdrop{opacity:.5}.mat-drawer-content{position:relative;z-index:1;display:block;height:100%;overflow:auto}.mat-drawer-transition .mat-drawer-content{transition-duration:400ms;transition-timing-function:cubic-bezier(0.25, 0.8, 0.25, 1);transition-property:transform,margin-left,margin-right}.mat-drawer{position:relative;z-index:4;color:var(--mat-sidenav-container-text-color);box-shadow:var(--mat-sidenav-container-elevation-shadow);background-color:var(--mat-sidenav-container-background-color);border-top-right-radius:var(--mat-sidenav-container-shape);border-bottom-right-radius:var(--mat-sidenav-container-shape);width:var(--mat-sidenav-container-width);display:block;position:absolute;top:0;bottom:0;z-index:3;outline:0;box-sizing:border-box;overflow-y:auto;transform:translate3d(-100%, 0, 0)}.cdk-high-contrast-active .mat-drawer,.cdk-high-contrast-active [dir=rtl] .mat-drawer.mat-drawer-end{border-right:solid 1px currentColor}.cdk-high-contrast-active [dir=rtl] .mat-drawer,.cdk-high-contrast-active .mat-drawer.mat-drawer-end{border-left:solid 1px currentColor;border-right:none}.mat-drawer.mat-drawer-side{z-index:2}.mat-drawer.mat-drawer-end{right:0;transform:translate3d(100%, 0, 0);border-top-left-radius:var(--mat-sidenav-container-shape);border-bottom-left-radius:var(--mat-sidenav-container-shape);border-top-right-radius:0;border-bottom-right-radius:0}[dir=rtl] .mat-drawer{border-top-left-radius:var(--mat-sidenav-container-shape);border-bottom-left-radius:var(--mat-sidenav-container-shape);border-top-right-radius:0;border-bottom-right-radius:0;transform:translate3d(100%, 0, 0)}[dir=rtl] .mat-drawer.mat-drawer-end{border-top-right-radius:var(--mat-sidenav-container-shape);border-bottom-right-radius:var(--mat-sidenav-container-shape);border-top-left-radius:0;border-bottom-left-radius:0;left:0;right:auto;transform:translate3d(-100%, 0, 0)}.mat-drawer[style*=\"visibility: hidden\"]{display:none}.mat-drawer-side{box-shadow:none;border-right-color:var(--mat-sidenav-container-divider-color);border-right-width:1px;border-right-style:solid}.mat-drawer-side.mat-drawer-end{border-left-color:var(--mat-sidenav-container-divider-color);border-left-width:1px;border-left-style:solid;border-right:none}[dir=rtl] .mat-drawer-side{border-left-color:var(--mat-sidenav-container-divider-color);border-left-width:1px;border-left-style:solid;border-right:none}[dir=rtl] .mat-drawer-side.mat-drawer-end{border-right-color:var(--mat-sidenav-container-divider-color);border-right-width:1px;border-right-style:solid;border-left:none}.mat-drawer-inner-container{width:100%;height:100%;overflow:auto;-webkit-overflow-scrolling:touch}.mat-sidenav-fixed{position:fixed}"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return MatDrawerContainer;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatSidenavContent = /*#__PURE__*/(() => {
  class MatSidenavContent extends MatDrawerContent {
    constructor(changeDetectorRef, container, elementRef, scrollDispatcher, ngZone) {
      super(changeDetectorRef, container, elementRef, scrollDispatcher, ngZone);
    }
    static {
      this.ɵfac = function MatSidenavContent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MatSidenavContent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(forwardRef(() => MatSidenavContainer)), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.ScrollDispatcher), i0.ɵɵdirectiveInject(i0.NgZone));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MatSidenavContent,
        selectors: [["mat-sidenav-content"]],
        hostAttrs: [1, "mat-drawer-content", "mat-sidenav-content"],
        hostVars: 4,
        hostBindings: function MatSidenavContent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("margin-left", ctx._container._contentMargins.left, "px")("margin-right", ctx._container._contentMargins.right, "px");
          }
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: CdkScrollable,
          useExisting: MatSidenavContent
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function MatSidenavContent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return MatSidenavContent;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatSidenav = /*#__PURE__*/(() => {
  class MatSidenav extends MatDrawer {
    constructor() {
      super(...arguments);
      this._fixedInViewport = false;
      this._fixedTopGap = 0;
      this._fixedBottomGap = 0;
    }
    /** Whether the sidenav is fixed in the viewport. */
    get fixedInViewport() {
      return this._fixedInViewport;
    }
    set fixedInViewport(value) {
      this._fixedInViewport = coerceBooleanProperty(value);
    }
    /**
     * The gap between the top of the sidenav and the top of the viewport when the sidenav is in fixed
     * mode.
     */
    get fixedTopGap() {
      return this._fixedTopGap;
    }
    set fixedTopGap(value) {
      this._fixedTopGap = coerceNumberProperty(value);
    }
    /**
     * The gap between the bottom of the sidenav and the bottom of the viewport when the sidenav is in
     * fixed mode.
     */
    get fixedBottomGap() {
      return this._fixedBottomGap;
    }
    set fixedBottomGap(value) {
      this._fixedBottomGap = coerceNumberProperty(value);
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵMatSidenav_BaseFactory;
        return function MatSidenav_Factory(__ngFactoryType__) {
          return (ɵMatSidenav_BaseFactory || (ɵMatSidenav_BaseFactory = i0.ɵɵgetInheritedFactory(MatSidenav)))(__ngFactoryType__ || MatSidenav);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MatSidenav,
        selectors: [["mat-sidenav"]],
        hostAttrs: ["tabIndex", "-1", 1, "mat-drawer", "mat-sidenav"],
        hostVars: 17,
        hostBindings: function MatSidenav_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("align", null);
            i0.ɵɵstyleProp("top", ctx.fixedInViewport ? ctx.fixedTopGap : null, "px")("bottom", ctx.fixedInViewport ? ctx.fixedBottomGap : null, "px");
            i0.ɵɵclassProp("mat-drawer-end", ctx.position === "end")("mat-drawer-over", ctx.mode === "over")("mat-drawer-push", ctx.mode === "push")("mat-drawer-side", ctx.mode === "side")("mat-drawer-opened", ctx.opened)("mat-sidenav-fixed", ctx.fixedInViewport);
          }
        },
        inputs: {
          fixedInViewport: "fixedInViewport",
          fixedTopGap: "fixedTopGap",
          fixedBottomGap: "fixedBottomGap"
        },
        exportAs: ["matSidenav"],
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c0,
        decls: 3,
        vars: 0,
        consts: [["content", ""], ["cdkScrollable", "", 1, "mat-drawer-inner-container"]],
        template: function MatSidenav_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
        },
        dependencies: [CdkScrollable],
        encapsulation: 2,
        data: {
          animation: [matDrawerAnimations.transformDrawer]
        },
        changeDetection: 0
      });
    }
  }
  return MatSidenav;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatSidenavContainer = /*#__PURE__*/(() => {
  class MatSidenavContainer extends MatDrawerContainer {
    constructor() {
      super(...arguments);
      this._allDrawers = undefined;
      // We need an initializer here to avoid a TS error.
      this._content = undefined;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵMatSidenavContainer_BaseFactory;
        return function MatSidenavContainer_Factory(__ngFactoryType__) {
          return (ɵMatSidenavContainer_BaseFactory || (ɵMatSidenavContainer_BaseFactory = i0.ɵɵgetInheritedFactory(MatSidenavContainer)))(__ngFactoryType__ || MatSidenavContainer);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MatSidenavContainer,
        selectors: [["mat-sidenav-container"]],
        contentQueries: function MatSidenavContainer_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, MatSidenavContent, 5);
            i0.ɵɵcontentQuery(dirIndex, MatSidenav, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._content = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._allDrawers = _t);
          }
        },
        hostAttrs: [1, "mat-drawer-container", "mat-sidenav-container"],
        hostVars: 2,
        hostBindings: function MatSidenavContainer_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("mat-drawer-container-explicit-backdrop", ctx._backdropOverride);
          }
        },
        exportAs: ["matSidenavContainer"],
        features: [i0.ɵɵProvidersFeature([{
          provide: MAT_DRAWER_CONTAINER,
          useExisting: MatSidenavContainer
        }]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c5,
        decls: 4,
        vars: 2,
        consts: [[1, "mat-drawer-backdrop", 3, "mat-drawer-shown"], [1, "mat-drawer-backdrop", 3, "click"]],
        template: function MatSidenavContainer_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c4);
            i0.ɵɵtemplate(0, MatSidenavContainer_Conditional_0_Template, 1, 2, "div", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵprojection(2, 1);
            i0.ɵɵtemplate(3, MatSidenavContainer_Conditional_3_Template, 2, 0, "mat-sidenav-content");
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.hasBackdrop ? 0 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(!ctx._content ? 3 : -1);
          }
        },
        dependencies: [MatSidenavContent],
        styles: [_c6],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return MatSidenavContainer;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatSidenavModule = /*#__PURE__*/(() => {
  class MatSidenavModule {
    static {
      this.ɵfac = function MatSidenavModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MatSidenavModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: MatSidenavModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [MatCommonModule, CdkScrollableModule, CdkScrollableModule, MatCommonModule]
      });
    }
  }
  return MatSidenavModule;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { MAT_DRAWER_DEFAULT_AUTOSIZE, MAT_DRAWER_DEFAULT_AUTOSIZE_FACTORY, MatDrawer, MatDrawerContainer, MatDrawerContent, MatSidenav, MatSidenavContainer, MatSidenavContent, MatSidenavModule, matDrawerAnimations, throwMatDuplicatedDrawerError };
